import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://hezxwwioilfowoyiugko.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhlenh3d2lvaWxmb3dveWl1Z2tvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIwNzkzMTAsImV4cCI6MjA4NzY1NTMxMH0.s23tm0QWCgtSI7RfzOhVeL7Ojd_P42KC6epHgHEHnIM';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
